import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { Form, FormMessage, FormControl, OrderFullDecorator, st } from "lib/index";

import { stateSelector, updateOrder, validate, submit } from "./index";

@connect(
  (state) => ({
    initialOrder: stateSelector(state).initialOrder,
    order: stateSelector(state).order,
    valid: stateSelector(state).valid,
    submitLoading: stateSelector(state).submitLoading,
    saved: stateSelector(state).saved,
    errors: stateSelector(state).errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateOrder,
        validate,
        submit,
      },
      dispatch
    )
)
export default class EditOrderNotesModalForm extends React.PureComponent {
  componentDidUpdate(prevProps) {
    const { saved, initialOrder, onSave } = this.props;
    if (saved && !prevProps.saved) {
      onSave(initialOrder);
    }
  }

  handleOrderPropChange(prop, value) {
    const { order, updateOrder } = this.props;
    updateOrder(
      new OrderFullDecorator({
        ...order,
        [prop]: value,
      })
    );
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.submit();
  }

  render() {
    const { onCancel, order, errors, valid, submitLoading, updateOrder, validate } = this.props;

    return (
      order && (
        <Form onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
          {!!errors.base && <FormMessage error={errors.base} />}

          <FormControl.TextAreaFormGroup
            value={order.additional_information}
            onChange={this.handleOrderPropChange.bind(this, "additional_information")}
            onBlur={validate}
            label={I18n.humanAttributeName("order", "additional_information")}
            autoHeight
          />

          <FormControl.TextAreaFormGroup
            value={order.internal_note}
            onChange={this.handleOrderPropChange.bind(this, "internal_note")}
            onBlur={validate}
            label={I18n.humanAttributeName("order", "internal_note")}
            autoHeight
          />

          {st.authorize("update_supplier_note", order) && (
            <FormControl.TextAreaFormGroup
              value={order.supplier_note}
              onChange={this.handleOrderPropChange.bind(this, "supplier_note")}
              onBlur={validate}
              label={I18n.humanAttributeName("order", "supplier_note")}
              autoHeight
            />
          )}

          {st.authorize("update_agent_note", order) && (
            <FormControl.TextAreaFormGroup
              value={order.agent_note}
              onChange={this.handleOrderPropChange.bind(this, "agent_note")}
              onBlur={validate}
              label={I18n.humanAttributeName("order", "agent_note")}
              autoHeight
            />
          )}

          {st.authorize("update_st_note", order) && (
            <FormControl.TextAreaFormGroup
              value={order.st_note}
              onChange={this.handleOrderPropChange.bind(this, "st_note")}
              onBlur={validate}
              label={I18n.humanAttributeName("order", "st_note")}
              autoHeight
            />
          )}

          <button type="submit" disabled={submitLoading} hidden />
        </Form>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/EditOrderNotesModal/EditOrderNotesModalForm.jsx